import type { Field } from "svelte-forms2/types";
import type { FormField } from "@shared/types/Form";

export type SvelteFormInputEvent = CustomEvent<{
  target: HTMLInputElement | HTMLSelectElement;
  field: FormField;
  fieldValue: Field<string>;
}>;

export const change = (e: SvelteFormInputEvent) => {
  const { fieldValue } = e.detail;

  fieldValue.dirty = true;
};

export const blur = (e: SvelteFormInputEvent) => {
  const { field, fieldValue } = e.detail;

  if (fieldValue.dirty) field.validate();
};

export const selectChange = (e: SvelteFormInputEvent) => {
  const { field, fieldValue, target } = e.detail;

  fieldValue.dirty = true;
  fieldValue.value = target.value;
  field.validate();
};
